const i = "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-action-focus focus-visible:ring-offset-1";
export {
  i as focusRing
};
